"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleModelLookupWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var core_1 = require("@athena-portal/core");
var journey_services_1 = require("@ferry/journey-services");
var React = require("react");
var moment = require("moment");
var rxjs_1 = require("rxjs");
var journey_services_2 = require("@athena-portal/journey-services");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var commonFunctions_1 = require("../../commonFunctions");
var VehicleModelLookupWidget = /** @class */ (function (_super) {
    __extends(VehicleModelLookupWidget, _super);
    function VehicleModelLookupWidget(props) {
        var _this = _super.call(this, props) || this;
        props.engine.toggleOverlay(true, "VehicleModelLookupWidget-fullVehicleModelYear-load");
        props.engine.toggleOverlay(true, "VehicleModelLookupWidget-selectedVehicleTransmission-load");
        props.engine.toggleOverlay(true, "VehicleModelLookupWidget-selectedVehicleFuelType-load");
        var vehicleManufacturer;
        _this.interactionVehicleManufacturer = _this.getSetting("interactionVehicleManufacturer", undefined);
        if (_this.interactionVehicleManufacturer) {
            vehicleManufacturer = journey_services_2.ObjectManipulator.fetchFieldValue(_this.interactionVehicleManufacturer, _this.props.interaction);
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionVehicleManufacturer' setting"));
        }
        var vehicleModel;
        _this.interactionVehicleModel = _this.getSetting("interactionVehicleModel", undefined);
        if (_this.interactionVehicleModel) {
            vehicleModel = journey_services_2.ObjectManipulator.fetchFieldValue(_this.interactionVehicleModel, _this.props.interaction);
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionVehicleModel' setting"));
        }
        var vehicleModelYear;
        _this.interactionVehicleModelYear = _this.getSetting("interactionVehicleModelYear", undefined);
        if (_this.interactionVehicleModelYear) {
            vehicleModelYear = journey_services_2.ObjectManipulator.fetchFieldValue(_this.interactionVehicleModelYear, _this.props.interaction);
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionVehicleModelYear' setting"));
        }
        _this.interactionVehiclePurchaseDate = _this.getSetting("interactionVehiclePurchaseDate", undefined);
        if (_this.interactionVehiclePurchaseDate) {
            _this.vehiclePurchaseDate = journey_services_2.ObjectManipulator.fetchFieldValue(_this.interactionVehiclePurchaseDate, _this.props.interaction);
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionVehiclePurchaseDate' setting"));
        }
        var vehicleTransmission;
        _this.interactionVehicleTransmission = _this.getSetting("interactionVehicleTransmission", undefined);
        if (_this.interactionVehicleTransmission) {
            vehicleTransmission = journey_services_2.ObjectManipulator.fetchFieldValue(_this.interactionVehicleTransmission, _this.props.interaction);
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionVehicleTransmission' setting"));
        }
        var vehicleFuelType;
        _this.interactionVehicleFuelType = _this.getSetting("interactionVehicleFuelType", undefined);
        if (_this.interactionVehicleFuelType) {
            vehicleFuelType = journey_services_2.ObjectManipulator.fetchFieldValue(_this.interactionVehicleFuelType, _this.props.interaction);
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionVehicleFuelType' setting"));
        }
        var vehicleFuelTypeFull;
        _this.interactionVehicleFuelTypeFull = _this.getSetting("interactionVehicleFuelTypeFull", undefined);
        if (_this.interactionVehicleFuelTypeFull) {
            vehicleFuelTypeFull = journey_services_2.ObjectManipulator.fetchFieldValue(_this.interactionVehicleFuelTypeFull, _this.props.interaction);
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionVehicleFuelTypeFull' setting"));
        }
        _this.carDetailsPage = _this.getSetting("carDetailsPage", undefined);
        if (!_this.carDetailsPage) {
            throw Error("".concat(_this.props.question.type, " widget is missing 'carDetailsPage' setting"));
        }
        _this.interactionVehicleManuallyChosen = _this.getSetting("interactionVehicleManuallyChosen", undefined);
        if (!_this.interactionVehicleManuallyChosen) {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionVehicleManuallyChosen' setting"));
        }
        var fullVehicleManufacturer = vehicleManufacturer ? vehicleManufacturer : null;
        var fullVehicleModel = vehicleModel ? vehicleModel : null;
        var fullVehicleModelYear = vehicleModelYear ? vehicleModelYear : null;
        var purchaseDateMonth = _this.vehiclePurchaseDate ? moment(_this.vehiclePurchaseDate).format("MM") : null;
        var purchaseDateYear = _this.vehiclePurchaseDate ? moment(_this.vehiclePurchaseDate).format("YYYY") : null;
        var fullVehiclePurchaseDate = _this.vehiclePurchaseDate ? "".concat(purchaseDateYear, "-").concat(purchaseDateMonth, "-01") : null;
        var selectedVehicleTransmission = vehicleTransmission ? vehicleTransmission : null;
        var vehicleFuelTypeActual = (0, commonFunctions_1.getInteractionVehicleFuelType)(vehicleFuelType, vehicleFuelTypeFull);
        var selectedVehicleFuelType = vehicleFuelTypeActual ? vehicleFuelTypeActual : null;
        _this.state = {
            fullVehicleManufacturer: fullVehicleManufacturer,
            fullVehicleModel: fullVehicleModel,
            fullVehicleModelYear: fullVehicleModelYear,
            fullVehiclePurchaseDate: fullVehiclePurchaseDate,
            purchaseDateMonth: purchaseDateMonth,
            purchaseDateYear: purchaseDateYear,
            purchaseMonthValid: "",
            purchaseYearValid: "",
            selectedVehicleTransmission: selectedVehicleTransmission,
            selectedVehicleFuelType: selectedVehicleFuelType,
            vehicleManufacturerList: [],
            vehicleModelList: [],
            vehicleModelYears: [],
            vehicleTransmissions: [],
            vehicleFuelTypes: [],
            typingTimeout: 0,
            subscription: rxjs_1.Subscription.EMPTY,
            modelReadOnly: true,
            modelYearReadOnly: false,
            manufacturerValid: "",
            manufacturerFound: "",
            manufacturerLoading: false,
            modelValid: "",
            modelFound: "",
            modelLoading: false,
            modelYearValid: "",
            modelYearLoading: false,
            transmissionValid: "",
            fuelTypeValid: ""
        };
        _this.handleManufacturerChange = _this.handleManufacturerChange.bind(_this);
        _this.handleModelChange = _this.handleModelChange.bind(_this);
        _this.handleModelYearChange = _this.handleModelYearChange.bind(_this);
        _this.onSelectVehicleManufacturer = _this.onSelectVehicleManufacturer.bind(_this);
        _this.onSelectVehicleModel = _this.onSelectVehicleModel.bind(_this);
        _this.onKeyPressVehicleManufacturer = _this.onKeyPressVehicleManufacturer.bind(_this);
        _this.onKeyPressVehicleModel = _this.onKeyPressVehicleModel.bind(_this);
        _this.onSelectVehicleTransmission = _this.onSelectVehicleTransmission.bind(_this);
        _this.onSelectVehicleFuelType = _this.onSelectVehicleFuelType.bind(_this);
        _this.allFieldsFilled = _this.allFieldsFilled.bind(_this);
        _this.navigate = _this.navigate.bind(_this);
        _this.loadModelsOnFirstClick = _this.loadModelsOnFirstClick.bind(_this);
        _this.logError = _this.logError.bind(_this);
        _this.handleOnPurchaseMonthChange = _this.handleOnPurchaseMonthChange.bind(_this);
        _this.handleOnPurchaseYearChange = _this.handleOnPurchaseYearChange.bind(_this);
        _this.bindPurchaseDateToField = _this.bindPurchaseDateToField.bind(_this);
        _this.findVehicleManufacturer(false);
        _this.findVehicleModelYear(fullVehicleManufacturer, false);
        _this.findVehicleTransmissions(fullVehicleManufacturer, parseInt(fullVehicleModelYear, 10), false);
        _this.findVehicleFuelTypes(fullVehicleManufacturer, parseInt(fullVehicleModelYear, 10), selectedVehicleTransmission, false);
        _this.findVehicleModel(false);
        return _this;
    }
    VehicleModelLookupWidget.prototype.componentDidCatch = function (error, errorInfo) {
        this.logError(error, errorInfo);
    };
    VehicleModelLookupWidget.prototype.renderInputField = function () {
        var vehicleModelYearsToRender = [];
        var isANewCar = this.props.interaction.uistate.isRecentlyRegisteredVehicle;
        if (this.state.vehicleModelYears && this.state.vehicleModelYears.length > 0) {
            var yearFrom = this.state.vehicleModelYears[0].yearMin;
            var yearTo = this.state.vehicleModelYears[0].yearMax;
            if (yearFrom && yearTo) {
                var yearsTotal = yearTo - yearFrom;
                for (var i = 0; i <= yearsTotal; i++) {
                    vehicleModelYearsToRender.push((0, jsx_runtime_1.jsx)("option", { value: yearTo - i, children: yearTo - i }, i));
                }
            }
        }
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "addressLookup w-100", children: [(0, jsx_runtime_1.jsx)("input", { type: "text", className: "form-control ".concat(this.isManufacturerLoading(), " ").concat(this.isManufacturerValid()), id: "vehicle-make", "aria-describedby": "makeDescription", value: this.state.fullVehicleManufacturer, onChange: this.handleManufacturerChange, placeholder: "Start typing the make of your vehicle..." }), (0, jsx_runtime_1.jsx)("div", { id: "makeDescription", "aria-label": this.ariaSuggestionsAvailableString(this.state.vehicleManufacturerList) }), this.renderFoundVehicleManufacturers(), this.state.manufacturerValid === 'is-invalid' && (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: "Make is mandatory." }), this.state.manufacturerFound === 'is-invalid' && (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: "Make not found. Please refine your criteria." })] }), (0, jsx_runtime_1.jsx)("br", {}), !(!this.state.fullVehicleManufacturer && isANewCar) &&
                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("label", { className: "mt-3", children: "Year of manufacture" }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group", "aria-live": "assertive", children: [(0, jsx_runtime_1.jsxs)("select", { value: this.state.fullVehicleModelYear, className: "form-control form-radius ".concat(this.isModelYearLoading(), " ").concat(this.isFieldValid(this.state.modelYearValid)), id: "vehicle-manufacture-year", "aria-describedby": "modelYarDescription", onChange: this.handleModelYearChange, disabled: this.state.modelYearReadOnly, children: [(0, jsx_runtime_1.jsx)("option", { value: '', children: "Please select..." }), vehicleModelYearsToRender] }), (0, jsx_runtime_1.jsx)("div", { id: "modelYarDescription", "aria-label": this.ariaSuggestionsAvailableString(vehicleModelYearsToRender) }), this.state.modelYearValid === 'is-invalid' && (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: "Year is mandatory." })] })] }), !(!this.state.fullVehicleModelYear && isANewCar) && this.vehiclePurchaseDate && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("label", { className: "mt-3", children: "Date of purchase" }), (0, jsx_runtime_1.jsx)("div", { className: "input-group", children: (0, jsx_runtime_1.jsxs)("div", { className: "customDate-container", children: [(0, jsx_runtime_1.jsxs)("div", { className: "custom-month", children: ["Month", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("input", { type: "text", className: "form-control customDate-month ".concat(this.isFieldValid(this.state.purchaseMonthValid)), value: this.state.purchaseDateMonth, "aria-label": "Purchase month input field", onChange: this.handleOnPurchaseMonthChange, onBlur: this.bindPurchaseDateToField, placeholder: "MM", pattern: "[0-9]*", maxLength: 2, disabled: !this.state.fullVehicleModelYear, id: "purchase-date-month" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "custom-month", children: ["Year", (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("input", { type: "text", className: "form-control customDate-year ".concat(this.isFieldValid(this.state.purchaseYearValid)), value: this.state.purchaseDateYear, "aria-label": "Purchase year input field", onChange: this.handleOnPurchaseYearChange, onBlur: this.bindPurchaseDateToField, placeholder: "YYYY", pattern: "[0-9]*", maxLength: 4, disabled: !this.state.fullVehicleModelYear, id: "purchase-date-year" })] })] }) }), (this.state.purchaseMonthValid === 'is-invalid' || this.state.purchaseYearValid === 'is-invalid')
                            && (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: this.purchaseDateErrorMessage })] }), !(!this.state.fullVehicleModelYear && isANewCar) && this.renderTransmissionRadioButtons(), !(!this.state.selectedVehicleTransmission && isANewCar) && this.renderFuelTypeRadioButtons(), !(!this.state.selectedVehicleFuelType && isANewCar) &&
                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("label", { className: "mt-3", children: "Model" }), (0, jsx_runtime_1.jsxs)("div", { className: "addressLookup w-100", children: [(0, jsx_runtime_1.jsx)("input", { type: "text", className: "form-control ".concat(this.isModelLoading(), " ").concat(this.isModelValid()), id: "vehicle-model", "aria-describedby": "modelDescription", value: this.state.fullVehicleModel, onChange: this.handleModelChange, onClick: this.loadModelsOnFirstClick, readOnly: this.state.modelReadOnly, placeholder: "Start typing the model name of your vehicle..." }), (0, jsx_runtime_1.jsx)("div", { id: "modelDescription", "aria-label": this.ariaSuggestionsAvailableString(this.state.vehicleModelList) }), this.renderFoundVehicleModels(), this.state.modelValid === 'is-invalid' && (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: "Model is mandatory." }), this.state.modelFound === 'is-invalid' && (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: "Model not found. Please refine your criteria." })] })] }), (0, jsx_runtime_1.jsx)("br", {}), !(!this.allFieldsFilled() && isANewCar) &&
                    (0, jsx_runtime_1.jsx)("button", { disabled: !this.allFieldsFilled(), onClick: this.navigate, className: "btn btn-default btn-primary btn-next btn-center-edit-car-details", role: "button", tabIndex: 0, children: "All done" })] }));
    };
    VehicleModelLookupWidget.prototype.findVehicleManufacturer = function (update) {
        var _this = this;
        if (update === void 0) { update = true; }
        if (this.state.fullVehicleManufacturer) {
            if (update) {
                this.state.subscription.unsubscribe();
                var sub = this.falconConvenienceApiService.getVehicleManufacturerDetails(this.state.fullVehicleManufacturer)
                    .subscribe(function (output) {
                    var vehicleManufacturerDetails = output;
                    _this.setState({
                        vehicleManufacturerList: vehicleManufacturerDetails,
                        fullVehicleModel: '',
                        fullVehicleModelYear: '',
                        modelValid: "",
                        modelYearValid: "",
                        manufacturerFound: output.length > 0 ? 'is-valid' : 'is-invalid',
                        manufacturerLoading: false
                    });
                }, function () {
                    _this.logError(new Error("Convenience API error(getVehicleManufacturerDetails)"));
                    _this.setState({
                        manufacturerLoading: false
                    });
                });
                this.setState({
                    subscription: sub
                });
            }
            else {
                this.setState({
                    vehicleManufacturerList: [],
                    manufacturerValid: 'is-valid'
                });
            }
            this.setState({
                manufacturerLoading: update
            });
        }
    };
    VehicleModelLookupWidget.prototype.loadModelsOnFirstClick = function (event) {
        if (!this.state.fullVehicleModel && this.state.fullVehicleManufacturer) {
            this.callVehicleModelService(false, this.state.fullVehicleManufacturer, "");
        }
    };
    VehicleModelLookupWidget.prototype.findVehicleModel = function (update) {
        if (update === void 0) { update = true; }
        if (this.state.fullVehicleManufacturer) {
            if (update) {
                var modelSearchString = this.state.fullVehicleModel ? this.state.fullVehicleModel : "";
                this.callVehicleModelService(update, this.state.fullVehicleManufacturer, modelSearchString);
            }
            else {
                this.setState({
                    vehicleModelList: [],
                    modelReadOnly: false,
                    modelValid: 'is-valid'
                });
            }
            this.setState({
                modelLoading: update
            });
        }
    };
    VehicleModelLookupWidget.prototype.findVehicleModelYear = function (manufacturer, update) {
        var _this = this;
        if (update === void 0) { update = true; }
        if (manufacturer) {
            this.state.subscription.unsubscribe();
            var sub = this.falconConvenienceApiService.getVehicleModelYears(manufacturer, null)
                .subscribe(function (output) {
                var vehicleModelYearsList = output;
                _this.setState({
                    modelYearLoading: false,
                    vehicleModelYears: vehicleModelYearsList
                });
                if (update) {
                    _this.setState({
                        fullVehicleModelYear: ''
                    });
                }
                else {
                    _this.setState({
                        modelYearReadOnly: output.length === 0,
                        modelYearValid: output.length > 0 ? 'is-valid' : 'is-invalid'
                    });
                }
                _this.props.engine.toggleOverlay(false, "VehicleModelLookupWidget-fullVehicleModelYear-load");
            }, function () {
                _this.props.engine.toggleOverlay(false, "VehicleModelLookupWidget-fullVehicleModelYear-load");
                _this.logError(new Error("Convenience API error(getVehicleModelYears)"));
                _this.setState({
                    modelYearLoading: false
                });
            });
            this.setState({
                subscription: sub,
                modelYearLoading: true
            });
        }
        else {
            this.props.engine.toggleOverlay(false, "VehicleModelLookupWidget-fullVehicleModelYear-load");
        }
    };
    VehicleModelLookupWidget.prototype.findVehicleTransmissions = function (manufacturer, year, update) {
        var _this = this;
        if (update === void 0) { update = true; }
        if (manufacturer && year) {
            this.state.subscription.unsubscribe();
            var sub = this.falconConvenienceApiService.getVehicleTransmissions(manufacturer, year, null)
                .subscribe(function (output) {
                var vehicleTransmissions = output;
                _this.setState({
                    vehicleTransmissions: vehicleTransmissions
                });
                _this.props.engine.toggleOverlay(false, "VehicleModelLookupWidget-selectedVehicleTransmission-load");
            }, function () {
                _this.props.engine.toggleOverlay(false, "VehicleModelLookupWidget-selectedVehicleTransmission-load");
                _this.logError(new Error("Convenience API error(getVehicleTransmissions)"));
            });
            this.setState({
                subscription: sub
            });
        }
        else {
            this.props.engine.toggleOverlay(false, "VehicleModelLookupWidget-selectedVehicleTransmission-load");
        }
    };
    VehicleModelLookupWidget.prototype.findVehicleFuelTypes = function (manufacturer, year, transmission, update) {
        var _this = this;
        if (update === void 0) { update = true; }
        if (manufacturer && year && transmission) {
            this.state.subscription.unsubscribe();
            var sub = this.falconConvenienceApiService.getVehicleFuelTypes(manufacturer, year, transmission, null)
                .subscribe(function (output) {
                var vehicleFuelTypes = output;
                _this.setState({
                    vehicleFuelTypes: vehicleFuelTypes
                });
                if (!update) {
                    _this.setState({
                        modelReadOnly: false
                    });
                }
                _this.props.engine.toggleOverlay(false, "VehicleModelLookupWidget-selectedVehicleFuelType-load");
            });
            this.setState({
                subscription: sub
            });
        }
        else {
            this.props.engine.toggleOverlay(false, "VehicleModelLookupWidget-selectedVehicleFuelType-load");
        }
    };
    VehicleModelLookupWidget.prototype.handleManufacturerChange = function (event) {
        var _this = this;
        var vehicleManufacturer = (event.target.validity.valid) ? event.target.value : this.state.fullVehicleManufacturer;
        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }
        this.setState({
            fullVehicleManufacturer: vehicleManufacturer,
            vehicleTransmissions: [],
            selectedVehicleTransmission: "",
            vehicleFuelTypes: [],
            selectedVehicleFuelType: "",
            fullVehicleModel: '',
            fullVehicleModelYear: '',
            typingTimeout: setTimeout(function () {
                _this.findVehicleManufacturer();
            }, this.props.question.settings.timeout),
            modelReadOnly: true,
            modelYearReadOnly: true,
            manufacturerValid: vehicleManufacturer.length > 0 ? 'is-valid' : 'is-invalid',
            modelValid: ""
        });
    };
    VehicleModelLookupWidget.prototype.handleModelChange = function (event) {
        var _this = this;
        var vehicleModel = (event.target.validity.valid) ? event.target.value : this.state.fullVehicleModel;
        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }
        this.setState({
            fullVehicleModel: vehicleModel,
            typingTimeout: setTimeout(function () {
                _this.findVehicleModel();
            }, this.props.question.settings.timeout),
            modelValid: vehicleModel.length > 0 ? 'is-valid' : 'is-invalid'
        });
    };
    VehicleModelLookupWidget.prototype.handleModelYearChange = function (event) {
        var manufacturer = this.state.fullVehicleManufacturer ? this.state.fullVehicleManufacturer : "";
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleManufacturer), this.state.fullVehicleManufacturer);
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleModelYear), event.target.value);
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleTransmission), '');
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleFuelType), '');
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleFuelTypeFull), '');
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleModel), '');
        this.props.onStateChange("".concat(this.props.question.interactionField), event.target.value);
        this.setState({
            fullVehicleModel: "",
            vehicleModelList: [],
            vehicleTransmissions: [],
            selectedVehicleTransmission: "",
            vehicleFuelTypes: [],
            selectedVehicleFuelType: "",
            fullVehicleModelYear: event.target.value,
            modelYearValid: event.target.value ? 'is-valid' : 'is-invalid',
            modelReadOnly: true,
            modelValid: ""
        });
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicleModelYear, this.props.page && this.props.page.pageId);
        this.findVehicleTransmissions(manufacturer, parseInt(event.target.value, 10));
    };
    VehicleModelLookupWidget.prototype.onSelectVehicleManufacturer = function (event) {
        var vehicleManufacturerDetails = this.state.vehicleManufacturerList[event.target.dataset.id];
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleManufacturer), vehicleManufacturerDetails);
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleModel), '');
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleModelYear), '');
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleTransmission), '');
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleFuelType), '');
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleFuelTypeFull), '');
        this.setState({
            fullVehicleManufacturer: event.target.textContent,
            vehicleManufacturerList: []
        });
        this.findVehicleModelYear(vehicleManufacturerDetails, true);
        this.setState({
            modelYearReadOnly: false
        });
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicleManufacturer, this.props.page && this.props.page.pageId);
    };
    VehicleModelLookupWidget.prototype.onSelectVehicleTransmission = function (event) {
        var newValue = event.target.value;
        var manufacturer = this.state.fullVehicleManufacturer ? this.state.fullVehicleManufacturer : "";
        var year = this.state.fullVehicleModelYear ? parseInt(this.state.fullVehicleModelYear, 10) : 0;
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleTransmission), newValue);
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleFuelType), '');
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleFuelTypeFull), '');
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleModel), '');
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicleTransmission, this.props.page && this.props.page.pageId);
        this.setState({
            fullVehicleModel: "",
            vehicleModelList: [],
            vehicleFuelTypes: [],
            selectedVehicleFuelType: "",
            selectedVehicleTransmission: newValue,
            modelReadOnly: true,
            modelValid: ""
        });
        this.findVehicleFuelTypes(manufacturer, year, newValue, true);
    };
    VehicleModelLookupWidget.prototype.onSelectVehicleFuelType = function (event) {
        var newValue = event.target.value;
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleFuelType), newValue);
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleFuelTypeFull), '');
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleModel), '');
        this.setState({
            selectedVehicleFuelType: newValue,
            fullVehicleModel: "",
            vehicleModelList: [],
            modelReadOnly: false
        });
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicleFuelType, this.props.page && this.props.page.pageId);
    };
    VehicleModelLookupWidget.prototype.onKeyPressVehicleManufacturer = function (event) {
        var activeEl = document.activeElement;
        if (event.key === "Enter") {
            this.onSelectVehicleManufacturer(event);
        }
        else if (event.key === "ArrowDown" && activeEl && activeEl.nextElementSibling && activeEl.nextElementSibling instanceof HTMLElement) {
            activeEl.nextElementSibling.focus();
        }
        else if (event.key === "ArrowUp" && activeEl && activeEl.previousElementSibling && activeEl.previousElementSibling instanceof HTMLElement) {
            activeEl.previousElementSibling.focus();
        }
    };
    VehicleModelLookupWidget.prototype.onSelectVehicleModel = function (event) {
        var vehicleModel = (event.target.validity.valid) ? event.target.value : this.state.fullVehicleModel;
        var vehicleModelDetails = this.state.vehicleModelList[event.target.dataset.id];
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleModel), vehicleModelDetails['model']);
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleFuelTypeFull), vehicleModelDetails['fuelTypeFull']);
        this.setState({
            fullVehicleModel: event.target.textContent,
            vehicleModelList: [],
            modelYearReadOnly: false,
            modelValid: vehicleModel.length > 0 ? 'is-valid' : 'is-invalid'
        });
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicleModel, this.props.page && this.props.page.pageId);
        this.changelogRecorder.record(this.props.engine.getInteraction(), "change", this.props.question.settings.interactionVehicleFuelTypeFull, this.props.page && this.props.page.pageId);
    };
    VehicleModelLookupWidget.prototype.onKeyPressVehicleModel = function (event) {
        var activeEl = document.activeElement;
        if (event.key === "Enter") {
            this.onSelectVehicleModel(event);
        }
        else if (event.key === "ArrowDown" && activeEl && activeEl.nextElementSibling && activeEl.nextElementSibling instanceof HTMLElement) {
            activeEl.nextElementSibling.focus();
        }
        else if (event.key === "ArrowUp" && activeEl && activeEl.previousElementSibling && activeEl.previousElementSibling instanceof HTMLElement) {
            activeEl.previousElementSibling.focus();
        }
    };
    VehicleModelLookupWidget.prototype.isManufacturerValid = function () {
        if (this.state.manufacturerValid === 'is-valid' && this.state.manufacturerFound === 'is-valid') {
            return 'is-valid';
        }
        else if (this.state.manufacturerValid === 'is-invalid' || this.state.manufacturerFound === 'is-invalid') {
            return 'is-invalid';
        }
        return "";
    };
    VehicleModelLookupWidget.prototype.isModelValid = function () {
        if (this.state.modelValid === 'is-valid' && this.state.modelFound === 'is-valid') {
            return 'is-valid';
        }
        else if (this.state.modelValid === 'is-invalid' || this.state.modelFound === 'is-invalid') {
            return 'is-invalid';
        }
        return "";
    };
    VehicleModelLookupWidget.prototype.isFieldValid = function (stateField) {
        if (stateField === 'is-valid') {
            return 'is-valid';
        }
        else if (stateField === 'is-invalid') {
            return 'is-invalid';
        }
        return "";
    };
    VehicleModelLookupWidget.prototype.isManufacturerLoading = function () {
        if (this.state.manufacturerLoading) {
            return 'loading-input';
        }
        return '';
    };
    VehicleModelLookupWidget.prototype.isModelLoading = function () {
        if (this.state.modelLoading) {
            return 'loading-input';
        }
        return '';
    };
    VehicleModelLookupWidget.prototype.isModelYearLoading = function () {
        if (this.state.modelYearLoading) {
            return 'loading-select';
        }
        return '';
    };
    VehicleModelLookupWidget.prototype.handleOnPurchaseMonthChange = function (event) {
        var purchaseDateMonth = (event.target.validity.valid) ? event.target.value : this.state.purchaseDateMonth;
        this.setState({ purchaseDateMonth: purchaseDateMonth });
    };
    VehicleModelLookupWidget.prototype.handleOnPurchaseYearChange = function (event) {
        var purchaseDateYear = event.target.validity.valid ? event.target.value : this.state.purchaseDateYear;
        this.setState({ purchaseDateYear: purchaseDateYear });
    };
    VehicleModelLookupWidget.prototype.bindPurchaseDateToField = function () {
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehiclePurchaseDate), undefined);
        var monthNumber = parseInt(this.state.purchaseDateMonth, 10);
        var currentYear = new Date().getFullYear();
        if (isNaN(monthNumber) || monthNumber < 1 || monthNumber > 12 || this.state.purchaseDateMonth.length !== 2) {
            this.purchaseDateErrorMessage = "Date is not valid. Example: 01/".concat(currentYear, ".");
            this.setState({
                purchaseMonthValid: 'is-invalid',
                fullVehiclePurchaseDate: undefined
            });
        }
        else {
            var month = this.state.purchaseDateMonth.length === 1 ? "0" + this.state.purchaseDateMonth : this.state.purchaseDateMonth;
            var purchaseDateString = "".concat(this.state.purchaseDateYear, "-").concat(month, "-01");
            var purchaseDate = moment(purchaseDateString);
            var validated = false;
            if (this.state.fullVehicleModelYear && this.state.purchaseDateYear) {
                validated = (this.state.purchaseDateYear >= this.state.fullVehicleModelYear && purchaseDate.isSameOrBefore(moment(), 'month'));
            }
            if (validated) {
                this.props.onStateChange("".concat(this.props.question.settings.interactionVehiclePurchaseDate), purchaseDateString);
                this.setState({
                    purchaseMonthValid: 'is-valid',
                    purchaseYearValid: 'is-valid',
                    fullVehiclePurchaseDate: purchaseDateString
                });
            }
            else {
                this.setState({
                    purchaseYearValid: 'is-invalid',
                    fullVehiclePurchaseDate: undefined
                });
                if (!this.state.purchaseDateYear) {
                    this.purchaseDateErrorMessage = "Purchase date is mandatory";
                }
                else {
                    purchaseDate.isAfter(moment(), 'month') ?
                        this.purchaseDateErrorMessage = "Purchase date cannot be this far in the future" :
                        this.purchaseDateErrorMessage = "Purchase date cannot be earlier than vehicle year of manufacture";
                }
            }
        }
    };
    VehicleModelLookupWidget.prototype.renderFoundVehicleManufacturers = function () {
        var _this = this;
        var vehicleManufacturers = [];
        if (this.state.vehicleManufacturerList && this.state.vehicleManufacturerList.length > 0) {
            var index_1 = 0;
            this.state.vehicleManufacturerList.forEach(function (vehicleManufacturer) {
                vehicleManufacturers.push((0, jsx_runtime_1.jsx)("li", { onClick: _this.onSelectVehicleManufacturer, onKeyDown: _this.onKeyPressVehicleManufacturer, "data-id": index_1, tabIndex: 0, children: vehicleManufacturer }, index_1));
                index_1++;
            });
            return ((0, jsx_runtime_1.jsx)("div", { className: "addressLookupWrapper", children: (0, jsx_runtime_1.jsx)("ul", { className: "addressesFound", children: vehicleManufacturers }) }));
        }
        else {
            return null;
        }
    };
    VehicleModelLookupWidget.prototype.renderTransmissionRadioButtons = function () {
        var _this = this;
        var radioButtons = [];
        var transmissionMap = new Map([
            ["Manual", "M"],
            ["Automatic", "A"],
            ["Semi-auto", "SA"],
            ["CVT", "CVT"]
        ]);
        transmissionMap.forEach(function (key, value) {
            radioButtons.push((0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input " + _this.state.transmissionValid, type: "radio", name: "vehicleTransmission" + key, id: "vehicleTransmission" + key, value: key, checked: _this.state.selectedVehicleTransmission === key, disabled: !_this.state.vehicleTransmissions.includes(key), onChange: _this.onSelectVehicleTransmission }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: "vehicleTransmission" + key, children: value })] }));
        });
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group mb-0", children: [(0, jsx_runtime_1.jsx)("label", { className: "mt-3", children: "Transmission" }), (0, jsx_runtime_1.jsx)("div", { className: "input-group width-450", role: "group", "aria-label": "Transmission", children: radioButtons }), this.state.transmissionValid === 'is-invalid' && (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: "Please answer this to carry on" })] }));
    };
    VehicleModelLookupWidget.prototype.renderFuelTypeRadioButtons = function () {
        var _this = this;
        var radioButtons = [];
        var fuelTypeMap = new Map([
            ["Petrol", "P"],
            ["Diesel", "D"],
            ["Hybrid", "H"],
            ["Electric", "E"]
        ]);
        fuelTypeMap.forEach(function (key, value) {
            radioButtons.push((0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { className: "custom-control-input " + _this.state.fuelTypeValid, type: "radio", name: "vehicleFuelType" + key, id: "vehicleFuelType" + key, value: key, checked: _this.state.selectedVehicleFuelType === key, disabled: !_this.state.vehicleFuelTypes.includes(key), onChange: _this.onSelectVehicleFuelType }), (0, jsx_runtime_1.jsx)("label", { className: "custom-control-label", htmlFor: "vehicleFuelType" + key, children: value })] }));
        });
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group mb-0", children: [(0, jsx_runtime_1.jsx)("label", { className: "mt-3", children: "Fuel type" }), (0, jsx_runtime_1.jsx)("div", { className: "input-group width-450", role: "group", "aria-label": "Fuel type", children: radioButtons }), this.state.fuelTypeValid === 'is-invalid' && (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: "Please answer this to carry on" })] }));
    };
    VehicleModelLookupWidget.prototype.renderFoundVehicleModels = function () {
        var _this = this;
        var vehicleModels = [];
        if (this.state.vehicleModelList && this.state.vehicleModelList.length > 0) {
            var index_2 = 0;
            this.state.vehicleModelList.forEach(function (vehicleModel) {
                var fullVehicleModel = _this.getFullVehicleModelString(vehicleModel);
                vehicleModels.push((0, jsx_runtime_1.jsx)("li", { onClick: _this.onSelectVehicleModel, onKeyDown: _this.onKeyPressVehicleModel, "data-id": index_2, tabIndex: 0, children: fullVehicleModel }, index_2));
                index_2++;
            });
            return ((0, jsx_runtime_1.jsx)("div", { className: "addressLookupWrapper", children: (0, jsx_runtime_1.jsx)("ul", { className: "addressesFound", children: vehicleModels }) }));
        }
        else {
            return null;
        }
    };
    VehicleModelLookupWidget.prototype.getFullVehicleModelString = function (vehicleModelDetails) {
        var modelName = vehicleModelDetails.model ? vehicleModelDetails.model : '';
        return modelName;
    };
    VehicleModelLookupWidget.prototype.ariaSuggestionsAvailableString = function (array) {
        var defaultSTR = "Suggestion size ";
        if (array && array.length > 0) {
            return defaultSTR + array.length;
        }
        else {
            return '';
        }
    };
    VehicleModelLookupWidget.prototype.allFieldsFilled = function () {
        var manufacturer = this.state.fullVehicleManufacturer;
        var makeYear = this.state.fullVehicleModelYear;
        var purchaseYear = this.vehiclePurchaseDate ? this.state.fullVehiclePurchaseDate : "date not editable";
        var transmission = this.state.selectedVehicleTransmission;
        var fuelType = this.state.selectedVehicleFuelType;
        var model = this.state.fullVehicleModel;
        return !manufacturer || !makeYear || !purchaseYear || !transmission || !fuelType || !model ? false : true;
    };
    VehicleModelLookupWidget.prototype.navigate = function () {
        this.props.onStateChange("".concat(this.props.question.settings.interactionVehicleManuallyChosen), true);
        this.props.engine.navigate("".concat(this.carDetailsPage), false);
    };
    VehicleModelLookupWidget.prototype.callVehicleModelService = function (update, manufacturer, model) {
        var _this = this;
        this.state.subscription.unsubscribe();
        var modelYear = parseInt(this.state.fullVehicleModelYear, 10);
        if (modelYear) {
            var sub = this.falconConvenienceApiService.getVehicleModelDetails(manufacturer, modelYear, this.state.selectedVehicleTransmission, this.state.selectedVehicleFuelType, model)
                .subscribe(function (output) {
                var vehicleModelDetails = output;
                _this.setState({
                    vehicleModelList: vehicleModelDetails,
                    modelFound: output.length > 0 ? 'is-valid' : 'is-invalid',
                    modelLoading: false
                });
            }, function () {
                _this.logError(new Error("Convenience API error(getVehicleModelDetails)"));
                _this.setState({
                    modelLoading: false
                });
            });
            this.setState({
                subscription: sub,
                modelLoading: update
            });
        }
        else {
            this.logError(new Error("Failed to parse model year form ".concat(this.state.fullVehicleModelYear)));
        }
    };
    VehicleModelLookupWidget.prototype.logError = function (error, errorInfo) {
        this.journeyRuntimeService.doBackendAction("log", this.props.interaction, {
            level: "ERROR",
            message: "VehicleModelLookupWidget exception: ".concat(error && error.message ? error.message : "", "\n    Interaction id: ").concat(this.props.interaction._id || "-", "\n    fullVehicleManufacturer: ").concat(this.state.fullVehicleManufacturer, "\n    fullVehicleModelYear: ").concat(this.state.fullVehicleModelYear, "\n    selectedVehicleTransmission: ").concat(this.state.selectedVehicleTransmission, "\n    selectedVehicleFuelType: ").concat(this.state.selectedVehicleFuelType, "\n    fullVehicleModel: ").concat(this.state.fullVehicleModel, "\n    ComponentStack: ").concat(errorInfo && errorInfo.componentStack || "-", "\n    Stack: ").concat(error && error.stack || "-")
        }, false).subscribe();
    };
    __decorate([
        (0, core_1.lazyInject)(journey_services_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], VehicleModelLookupWidget.prototype, "falconConvenienceApiService", void 0);
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.JourneyRuntimeService),
        __metadata("design:type", Object)
    ], VehicleModelLookupWidget.prototype, "journeyRuntimeService", void 0);
    return VehicleModelLookupWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.VehicleModelLookupWidget = VehicleModelLookupWidget;
//# sourceMappingURL=VehicleModelLookupWidget.js.map